import { useSelector } from 'react-redux';
import logoImg from '../assets/images/logo.png';
function Navbar({setmenu}) {
  const cart = useSelector((state) => state.cart); 
  const qty = cart.reduce((preQty, curQty)=> curQty.qty + preQty,0);  
  const setMenu = (menu)=> setmenu(menu);
    return (
    <nav className="bg-[#171C2A] py-4">
      <div className="navBar">
        <a href="index.html">
          <img src={logoImg} alt="LWS" className="max-w-[140px]" />
        </a>  
        <div className="flex gap-4">
          <a onClick={()=> setMenu('home')} href="#home" className="navHome" id="lws-home"> Home </a>
          <a onClick={()=> setMenu('cart')} href="#cart" className="navCart" id="lws-cart">
            <i className="text-xl fa-sharp fa-solid fa-bag-shopping"></i>
            <span id="lws-totalCart">{qty}</span>
          </a>
        </div>
      </div>
    </nav>
    );
}
export default Navbar;